import { render } from "./RanksByGroup.vue?vue&type=template&id=7c53a3b3"
import script from "./RanksByGroup.vue?vue&type=script&lang=js"
export * from "./RanksByGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__